import axios from 'axios'

export default axios.create ({
    baseURL: 'https://simple-streams.herokuapp.com/'
})